export default __webpack_public_path__ + "static/media/signup.22adaec3.jpg";